import React, { useState, useEffect, useRef } from "react";
import '../../styles/Common/TextBoxPlain.scss'

function TextBoxPlain({
  label = "",
  type = "text",
  value = "",
  onChange = () => { },
  onBlur = () => { },
  onFocus = () => { },
  name = "",
  id = "",
  disabled = false,
  required = false,
  maxLength = "",
  autoFocus = false,
  adornmentStart = null,
  adornmentEnd = null,
  clearable = false,
}) {
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const showLabelUp = focused || value;

  return (
    <div className="plainInput">
      <div className={`text-field-root ${disabled ? "disabled" : ""}`}>
        {adornmentStart && <div className="adornment start">{adornmentStart}</div>}
        <div className="input-wrapper">
          <input
            ref={inputRef}
            id={id || name}
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            onBlur={(e) => {
              setFocused(false);
              setTouched(true);
              onBlur(e);
            }}
            onFocus={(e) => {
              setFocused(true);
              onFocus(e);
            }}
            disabled={disabled}
            maxLength={maxLength}
          />
          <label htmlFor={id || name} className={showLabelUp ? "float" : ""}>
            {label}
            {required && <span className="required">*</span>}
          </label>
          {clearable && value && !disabled && (
            <div className="clear-icon" onClick={() => onChange({ target: { name, value: "" } })}>
              ×
            </div>
          )}
        </div>
        {adornmentEnd && <div className="adornment end">{adornmentEnd}</div>}
      </div>
    </div>

  );
}

export default TextBoxPlain;
